import { Injectable } from '@angular/core';
import { NavigationEnd, Router, UrlTree } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
  private readonly urls = new Map<string, string>();

  constructor(private router: Router) {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        const url = this.router.parseUrl(event.urlAfterRedirects);
        this.urls.set(this.pathOf(url), event.urlAfterRedirects);
      });
  }

  restore(target: UrlTree): UrlTree {
    const remembered = this.urls.get(this.pathOf(target));
    return remembered ? this.router.parseUrl(remembered) : target;
  }

  private pathOf(url: UrlTree): string {
    const path = this.router.serializeUrl(url).split(/[?#]/)[0];
    return path.replace(/\/$/, '') || '/';
  }
}
